import { Playground, Props } from 'docz';
import Component from 'react-component-component';
import { Carousel, Chip, Panel, PanelItem } from "../../../../../src";
import ProductCard from "../../../../../documentation/components/helpers/ProductCard";
import Chips from "../../../../../documentation/components/helpers/Chips";
import * as React from 'react';
export default {
  Playground,
  Props,
  Component,
  Carousel,
  Chip,
  Panel,
  PanelItem,
  ProductCard,
  Chips,
  React
};